import React, { useCallback, useMemo, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import {
  DEMO_ADVERTISER,
  DEMO_ADVERTISER_ID,
  DEMO_SESSION,
  DEMO_USER,
} from "./config";

// Drop-in replacement for AuthProvider when REACT_APP_DEMO_MODE === 'true'.
// Provides the exact value shape useAuth() consumers expect, but synthesized
// in-memory so no real Supabase auth round-trip is needed and the user lands
// directly on the dashboard for advertiser 1000003.
export function DemoAuthProvider({ children }) {
  const [userFirstName, setUserFirstName] = useState(DEMO_USER.first_name);

  const advertisers = useMemo(
    () => [
      {
        id: DEMO_ADVERTISER_ID,
        name: DEMO_ADVERTISER.name,
        role: "admin",
        billing_enabled: true,
        is_primary: true,
      },
    ],
    [],
  );

  const noop = useCallback(() => {}, []);
  const noopAsync = useCallback(async () => ({ data: null, error: null }), []);

  const updateFirstName = useCallback(async (name) => {
    const trimmed = (name || "").trim();
    if (trimmed) setUserFirstName(trimmed);
    return { error: null };
  }, []);

  const value = useMemo(
    () => ({
      session: DEMO_SESSION,
      user: DEMO_SESSION.user,
      userId: DEMO_USER.id,
      userFirstName,
      loading: false,
      signIn: noopAsync,
      signOut: noopAsync,
      updateFirstName,
      isConfigured: true,
      isSupportUser: false,
      currentMembership: advertisers[0],
      canViewAdvertiserData: true,
      canManageAdvertiserData: true,
      canManageBilling: true,
      isAdvertiserAdmin: true,
      advertisers,
      advertisersLoading: false,
      currentAdvertiserId: DEMO_ADVERTISER_ID,
      setCurrentAdvertiserId: noop,
      effectiveAdvertiserId: DEMO_ADVERTISER_ID,
      effectiveAdvertiserName: DEMO_ADVERTISER.name,
      masqueradeAdvertiserId: null,
      masqueradeAdvertiserName: "",
      setMasquerade: noop,
      clearMasquerade: noop,
    }),
    [advertisers, noop, noopAsync, updateFirstName, userFirstName],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
